import { render, staticRenderFns } from "./GraphTransactions.vue?vue&type=template&id=51d3b8b2&scoped=true&"
import script from "./GraphTransactions.vue?vue&type=script&lang=js&"
export * from "./GraphTransactions.vue?vue&type=script&lang=js&"
import style0 from "./GraphTransactions.vue?vue&type=style&index=0&id=51d3b8b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d3b8b2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSparkline } from 'vuetify/lib/components/VSparkline';
installComponents(component, {VSparkline})
